import { put, takeEvery, all, call } from 'redux-saga/effects';
import * as I18n from 'circe/I18n';
import { exception } from 'circe/logger';
import { show as showMessage } from 'circe/notifications/actions';
import { save, saved, saving, failedToSave } from './actions';
import * as api from './api';
import { startSubmit, stopSubmit } from 'circe/forms/actions';
import { FORM_NAME } from '../constants';

function* doSave({ payload }) {
  yield put(saving());

  const { data, shipperId } = payload;

  yield put(startSubmit(FORM_NAME));

  try {
    const resp = yield call(api.save, [{ ...data, shipperId }]);

    yield put(
      showMessage(
        I18n.str('yourDiscountAppliedSuccessfully', 'Your discount applied successfully'),
      ),
    );
    yield put(saved());
    yield put(stopSubmit(FORM_NAME));
  } catch (e) {
    exception(e);

    yield put(failedToSave(e.response));

    const message =
      e?.response?.data?.message || I18n.str('unableToApplyDiscount', 'Unable to apply discount!');

    yield put(showMessage(message, 'error'));

    yield put(stopSubmit(FORM_NAME));
  }
}

function* watcher(context) {
  yield all([takeEvery(save().type, doSave)]);
}

export default watcher;
